module.exports = __webpack_public_path__ + "img/699.9cfaa65c.jpg";